import { useLocation, useNavigate } from 'react-router-dom';

import { REDE_PROTO_BASE, SUBNAV } from '../../../../../../constants/redeProto';
import { Nav, NavItem } from './styles';

export function SubNav(): JSX.Element {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const isActive = (path: string): boolean => {
    const target = path ? `${REDE_PROTO_BASE}/${path}` : REDE_PROTO_BASE;
    if (path === '') {
      return pathname === REDE_PROTO_BASE || pathname === `${REDE_PROTO_BASE}/`;
    }
    return pathname === target || pathname.startsWith(`${target}/`);
  };

  return (
    <Nav>
      {SUBNAV.map((item) => (
        <NavItem
          key={item.path || 'overview'}
          type="button"
          active={isActive(item.path)}
          onClick={() =>
            navigate(
              item.path ? `${REDE_PROTO_BASE}/${item.path}` : REDE_PROTO_BASE
            )
          }
        >
          {item.label}
        </NavItem>
      ))}
    </Nav>
  );
}
